import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as uuid from 'uuid';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeDeExtra from '@angular/common/locales/extra/de';

registerLocaleData(localeIt, 'it-IT', localeDeExtra);

@Component({
  selector: 'app-subpanel',
  standalone: false,
  templateUrl: './subpanel.component.html',
  styleUrl: './subpanel.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class SubpanelComponent implements OnInit {
  
    @Output() messageEvent  = new EventEmitter<any>();
  
    @Input() public editable: boolean = true;
    @Input() public listUrl: string='' ;
    @Input() public subPanel: string ='';
    @Input() public module: string ='';
    @Input() public nuovoLabel: string ='';
    @Input() public listParams: any | undefined;
    @Input() public reorderable: boolean = false;
    
    @ViewChild('maintable') maintable:any;
    @ViewChild('filter') filter!: ElementRef;
      
    dataList:any[]=[];
    clonedSez:any[]=[];
    cols:any[]=[];
    loading:boolean = true;

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    public router: Router,
  ) { }

    ngOnInit(): void {  

      this.globalService.configModules.forEach((m:any)=>{
        if((m.name==this.module)&&(m[this.subPanel])){
          this.cols=m[this.subPanel];
        }
      })
     
      this.apiService.post(this.listUrl,this.listParams).subscribe(data2 => {
        this.dataList=data2.Result;
        this.loading = false;
      });
    }

    nuovoRecord() {
      let newS:any = {};
      this.cols.forEach((e) => {
        newS[e.field]='';
      });
      newS['id']=uuid.v4()
      this.dataList.unshift(newS);
      this.maintable.editingRowKeys[newS[this.maintable.dataKey]] = true;
      this.onRowEditInit(newS);
      this.messageEvent.emit(this.dataList);
    }
  
    
  
    onRowEditInit(sez: any) {
      this.clonedSez[sez.id] = { ...sez };
    }
    
    onEditComplete(event:any){
      this.messageEvent.emit(this.dataList);
    }

    onRowEditSave(record: any) {
      if (record.id!='') {
        delete this.clonedSez[record.id];
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'campo obbligatorio',
        });
      }
      this.messageEvent.emit(this.dataList);
    }
  
    onRowEditCancel(camera: any, index: number) {
      this.dataList[index] = this.clonedSez[camera.id];
      delete this.dataList[camera.id];
    }
  
    deleteRecord(record: any){
      this.dataList = this.dataList.filter((item:any) => item.id !== record.id);
      this.messageEvent.emit(this.dataList);
    }
    
    addSingle(sev: string, sum: string, det: string) {
      this.messageService.add({severity: sev, summary: sum, detail: det});
    }
    
    onGlobalFilter(table: Table, event: Event) {
      table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }
    
    getLabel(campo:string,val:any){
      let f=this.cols.filter((x:any)=> x.field==campo)[0].options.filter((x:any)=> x.value==val);
      if((f)&&(f.length>0)){
        return f[0].label;
      } else {
        return '';
      }
    }

    settings(record:any){

    }
    delete(record:any){

    }
    edit(record:any){

    }
  }
